import { faBuilding, faUserFriends } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import styled from "styled-components";

import { TitleArea, Title, Board } from "components/LayoutParts";
import TabBar from "components/TabBar";
import { useFindOwnerEntity } from "pages/PitPort/OwnerEntity/api";

const TabBarWrap = styled.div`
  padding: 0 0 37px 0;
`;

/**
 * 貸主詳細画面のタブ
 */
const TitleTabArea = () => {
  const { id: ownerEntityId } = useParams();
  const { data: ownerEntity } = useFindOwnerEntity({ ownerEntityId: ownerEntityId as string });
  const navigate = useNavigate();
  const location = useLocation();

  const isOwnerEntityPage = location.pathname === `/pit_port/owner-entities/${ownerEntityId}`;
  const isUsersPage = location.pathname === `/pit_port/owner-entities/${ownerEntityId}/owner-users`;

  return (
    <Board>
      <TitleArea>
        <Title>{ownerEntity?.data.name}</Title>
      </TitleArea>
      <TabBarWrap>
        <TabBar
          options={[
            {
              label: "貸主情報",
              onClick: () => navigate(`/pit_port/owner-entities/${ownerEntityId}`),
              Icon: <FontAwesomeIcon icon={faBuilding} width={12} height={16} />,
              width: 80,
              matchUrlKey: isOwnerEntityPage ? [] : ["active"],
            },
            {
              label: "ユーザ情報",
              onClick: () => navigate(`/pit_port/owner-entities/${ownerEntityId}/owner-users`),
              Icon: <FontAwesomeIcon icon={faUserFriends} width={18} height={14} />,
              width: 96,
              matchUrlKey: isUsersPage ? [] : ["active"],
            },
          ]}
        />
      </TabBarWrap>
      <Outlet />
    </Board>
  );
};

export default TitleTabArea;
